import React from 'react';

const CurrencyFormat = (props) => {
    if (!props.value) return '$ 0';
    const val = parseInt(props.value);
    return '$ ' + val.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
}

export default CurrencyFormat;